<script lang="ts">
	import { getTranslate } from '@tolgee/svelte';
	import { NOTIFICATION, notificationStore } from '$lib/store/notification.store';
	import { getVariantIdFromShopifyUri } from '$lib/utils';
	import { page } from '$app/stores';
	import { subscribeToBackInStock } from '$lib/klaviyo';
	import { field, form } from 'svelte-forms';
	import { email, required } from 'svelte-forms/validators';
	import FormFieldTextInput from '$lib/components/Form/FormFieldTextInput.svelte';
	import FormFieldCheckbox from '$lib/components/Form/FormFieldCheckbox.svelte';
	import ButtonPrimary from '$lib/components/Button/ButtonPrimary.svelte';
	import ProductCardHorizontalProduct from '$lib/components/Product/ProductCardHorizontalProduct.svelte';
	import { classes } from '@thearc-hq/ui-kit/utils';
	import { customer } from '$lib/store/customer.store';
	import { outOfStockDrawerExpanded } from '$lib/store/outOfStock.store';

	const { t } = getTranslate();

	const notifyForOption = async (email: string) => {
		try {
			const res = await subscribeToBackInStock(
				email,
				getVariantIdFromShopifyUri($page.data.product.variant.id)
			);
			if (res.status !== 200) {
				notificationStore.addNotification({
					hideAfter: 3000,
					text: $t('product.notify.error.text'),
					title: $t('product.notify.error.title'),
					variant: NOTIFICATION.ERROR
				});
				return;
			}
			notificationStore.addNotification({
				hideAfter: 3000,
				text: $t('product.notify.success.text'),
				title: $t('product.notify.success.title'),
				variant: NOTIFICATION.SUCCESS
			});
		} catch {
			notificationStore.addNotification({
				hideAfter: 3000,
				text: $t('product.notify.error.text'),
				title: $t('product.notify.error.title'),
				variant: NOTIFICATION.ERROR
			});
		}

		/*
        * TODO(@Marco): Add GTM
       sendDataToGTM(
            getGtmPayloadProductNotificationSignUp({
              productVariantDetails: {
                price: variant.price.amount,
                product_category: product.collections.edges[0]?.node.title ?? '',
                variant_id: variant.sku ?? '',
              },
            }),
        );
        * */

		/*if (onSubmit) {
				onSubmit();
			}
			TODO: Implement onClose
			*/
	};

	const emailField = field('email', $customer?.email || '', [email(), required()]);
	const acceptField = field('accept', false, [required()]);
	const formData = form(emailField, acceptField);

	const handleSubmit = async () => {
		await formData.validate();
		if ($formData.valid) {
			await notifyForOption($emailField.value);
		}
	};
</script>

{#if $outOfStockDrawerExpanded}
	<div
		on:click={() => outOfStockDrawerExpanded.set(false)}
		class="absolute w-full h-full left-0 top-0"
	></div>
{/if}
<div
	class={classes(
		'fixed p-4 right-0 top-0 transform transition duration-500 md:min-w-sm max-w-sm bg-white h-full z-50',
		$outOfStockDrawerExpanded ? '' : 'translate-x-full'
	)}
>
	<div class="flex justify-end">
		<button
			on:click={() => outOfStockDrawerExpanded.set(false)}
			class="i-sprenger-x-circle text-accent-primary w-10 h-10"
		></button>
	</div>
	<form on:submit={handleSubmit} class="flex flex-col items-stretch gap-8 mt-8">
		<div class="text-h-24">{$t('product.updates.headline')}</div>
		<div class="text-p-14">{$t('product.updates.subHeadline')}</div>

		<ProductCardHorizontalProduct data={$page.data.product} />

		<FormFieldTextInput
			required={true}
			name="email"
			errors={$formData.errors}
			label={$t('customer.email')}
			type="email"
			bind:value={$emailField.value}
		/>

		<FormFieldCheckbox
			bind:checked={$acceptField.value}
			required={true}
			errors={$formData.errors}
			name="accept"
		>
			{$t('product.updates.consent')}
		</FormFieldCheckbox>

		<ButtonPrimary
			type="submit"
			disabled={Object.keys($formData.errors).length > 0 || !$acceptField.value}
			text={$t('product.updates.submit')}
		/>
	</form>
</div>
